import { render, staticRenderFns } from "./BTongKetBenhAn.vue?vue&type=template&id=77da9df3"
import script from "./BTongKetBenhAn.vue?vue&type=script&lang=js"
export * from "./BTongKetBenhAn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports